import { FilterFilled } from '@ant-design/icons';
import { Button, Checkbox, Col, Input, Modal, Row, Select, Tooltip } from "antd";
import Title from "antd/es/typography/Title";
import { APP_LOCAL_DATE_FORMAT_PAYLOAD } from "app/config/constants";
import { useAppDispatch, useAppSelector } from "app/config/store";
import { getCheckInByAccountableId, getCurrentCheckInType } from "app/entities/checkIn/checkIn.reducer";
import { getCheckInPeriod } from 'app/entities/common/common.reducer';
import SelfEvaluationObjectiveKRComponent from 'app/entities/evaluation-level/view/modal/self-evaluation-objective';
import { setFilterOrgCheckIn } from "app/entities/filters/filters.reducer";
import { ReportKr as ReportDraftYear } from 'app/entities/kr/form/report/draft-year/reportKr';
import { ReportKr as ReportMidYear } from 'app/entities/kr/form/report/form/reportKr';
import { ReportKr as ReportHalfMonth } from 'app/entities/kr/form/report/half-month/reportKr';
import { ReportKr as ReportMonth } from 'app/entities/kr/form/report/month/reportKr';
import { ReportKr as ReportQuarter } from 'app/entities/kr/form/report/quarter/reportKr';
import { ReportKr as ReportYear } from 'app/entities/kr/form/report/year/reportKr';
import TableComponent from "app/shared/component/table/table";
import { CheckInType, CurrentCheckInType } from 'app/shared/model/enum/checkIn-type.enum';
import { PlantPeriodType } from "app/shared/model/enum/plantPeriod.enum";
import { overridePaginationStateWithQueryParams } from "app/shared/util/entity-utils";
import { DESC, ITEMS_PER_PAGE } from "app/shared/util/pagination.constants";
import { filterOption } from "app/shared/util/select-filter";
import dayjs from "dayjs";
import * as _ from 'lodash';
import React, { useEffect, useState } from "react";
import { getPaginationState } from "react-jhipster";
import { useLocation } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { Container } from "reactstrap";
import { columns, columnsExpand, krCheckInStatus } from "../../config";
import FilterCheckInModal from '../../filter/filter-check-in';
import ConfirmComplete from "../confirm-complete";
import ConfirmCompleteDraftYear from '../confirm-complete-draft-year';
import ConfirmCompleteQuarter from "../confirm-complete-quarter";
import { ConfirmComplete as ConfirmCompleteHalfMonth } from '../half-month/confirm-complete';
import { ConfirmComplete as ConfirmCompleteMonth } from '../month/confirm-complete';
import OtherCommentComponent from 'app/entities/evaluation-level/view/modal/other-comment';
import { getOtherComment } from 'app/entities/evaluation-level/view/modal/category-evaluation.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { Search } = Input;

type IOrganizationActiveCheckIn = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
}
const OrganizationActiveCheckIn = ({ isOpen, onClose }: IOrganizationActiveCheckIn) => {
    const dispatch = useAppDispatch();
    const pageLocation = useLocation();

    const objectiveCheckIns = useAppSelector(state => state.checkIn.entities);
    const totalItems = useAppSelector(state => state.checkIn.totalItems);
    const isLoading = useAppSelector(state => state.checkIn.loading);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const filters = useAppSelector(state => state.filters.orgCheckIn);
    const checkInPeriods = useAppSelector(state => state.common.checkInPeriod);
    const otherComment = useAppSelector(state => state.categoryEvaluation.otherComment);

    // init state variables
    const [paginationState, setPaginationState] = useState(
        overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
    );
    const [krBaseSelected, setKrBaseSelected] = useState(null);
    const [visibleFilter, setFilterModalVisible] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [data, setData] = useState([]);
    const [checkedList, setCheckedList] = useState<string[]>(['action']);
    const [columnConfig, setColumnConfig] = useState<any[]>([]);
    const [isOpenModalReportKr, setOpenModalReportKr] = useState(false);
    const [isOpenModalReportKrFirstQuarter, setOpenModalReportKrFirstQuarter] = useState(false);
    const [isOpenModalConfirmComplete, setOpenModalConfirmComplete] = useState(false);
    const [isOpenModalConfirmCompleteQuarter, setOpenModalConfirmCompleteQuarter] = useState(false);
    const [isOpenModalReportKrHalfMonth, setOpenModalReportKrHalfMonth] = useState(false);
    const [isOpenModalReportKrMonth, setOpenModalReportKrMonth] = useState(false);
    const [isOpenModalReportDraftKrYear, setOpenModalReportDraftKrYear] = useState(false);
    const [isOpenModalReportKrYear, setOpenModalReportKrYear] = useState(false);
    const [isOpenModalConfirmCompleteHalfMonth, setOpenModalConfirmCompleteHalfMonth] = useState(false);
    const [isOpenModalConfirmCompleteMonth, setOpenModalConfirmCompleteMonth] = useState(false);
    const [isOpenModalConfirmCompleteDraftYear, setOpenModalConfirmCompleteDraftYear] = useState(false);
    const [currentCheckInType, setCurrentCheckInType] = useState(null);
    const [isOpenModalEvaluateYear, setOpenModalEvaluateYear] = useState(null);
    const [isOpenModalOtherComment, setOpenModalOtherComment] = useState(false);
    const [isLoadingComment, setLoadingComment] = useState(false);
    const [isReload, setReload] = useState(false);

    useEffect(() => {
        dispatch(getCheckInPeriod())
        handleCurrentCheckIn()
    }, [])

    useEffect(() => {
        setCheckedList(_.uniq([...checkedList, ...[...createPinColumns(), ...columns, ...columnsExpand].map(x => {
            if (x.defaultShow) {
                return x.key
            }
        }
        )]));
    }, [filters.planPeriodType]);

    useEffect(() => {
        if (isReload) {
            getAllEntities();
        }
    }, [isReload])

    useEffect(() => {
        setColumnConfig(createColumns());
    }, [checkedList, currentCheckInType]);

    useEffect(() => {
        if (objectiveCheckIns) {
            // Extract keys of all rows for expanding all rows
            const allRowKeys = getAllRowKeys(objectiveCheckIns);
            setExpandedRowKeys(allRowKeys);
            setData(
                objectiveCheckIns?.map(item => {
                    return {
                        ...item,
                        contribution: item.contribution,
                        children:
                            item.keyResults &&
                            item.keyResults.map(child => {
                                return {
                                    ...child,
                                };
                            }),
                    };
                }),
            );
        }
    }, [objectiveCheckIns]);



    useEffect(() => {
        handleChangePeriodCheckIn(checkInPeriods[0]?.periodType);
    }, [checkInPeriods]);

    useEffect(() => {
        if (filters?.checkInPeriod) {
            getAllEntities();
        }
    }, [filters]);

    const newColumns = columnConfig.map(item => ({
        ...item,
        hidden: !checkedList.includes(item.key),
    }));

    const pinColumns: any = [
        {
            title: 'Mã',
            sorter: true,
            width: 90,
            fixed: 'left',
            key: 'code',
            defaultShow: true,
            dataIndex: 'code',
        },
        {
            title: 'Lĩnh vực,Dự án,Mảng CV',
            key: 'fieldName',
            fixed: 'left',
            width: 120,
            render(item) {
                const { fieldName, projectName, workTypeName } = item;

                if (!fieldName && !projectName && !workTypeName) return null;

                const segments = [fieldName, projectName, workTypeName].filter(Boolean);

                return (
                    <div>
                        {segments.map((segment, index) => (
                            <p key={index}>- {segment}</p>
                        ))}
                    </div>
                );
            }
        },
    ];

    const createPinColumns = () => {
        if (filters?.planPeriodType === PlantPeriodType.Quarter) {
            pinColumns.push(
                {
                    title: 'Mục tiêu và KR cả năm',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeYear',
                    render: value => (
                        <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
                    ),
                },
                {
                    title: 'KR quý',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeQuarter',
                    dataIndex: 'purposeQuarter'
                })
        }
        else if (filters?.planPeriodType === PlantPeriodType.Month) {
            pinColumns.push(
                {
                    title: 'Mục tiêu và KR cả năm',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeYear',
                    render: value => (
                        <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
                    ),
                },
                {
                    title: 'KR quý',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeQuarter',
                    dataIndex: 'purposeQuarter'
                },
                {
                    title: 'KR tháng',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeMonth',
                    dataIndex: 'purposeMonth'
                })
        }
        else {
            pinColumns.push(
                {
                    title: 'Mục tiêu và Kết quả then chốt',
                    fixed: 'left',
                    sorter: true,
                    width: 250,
                    defaultShow: true,
                    key: 'purposeYear',
                    render: value => (
                        <div className={`${!value.objectiveId ? 'fw-bold' : ''}`}>{value.purposeYear}</div>
                    ),
                })
        }
        return pinColumns;
    }

    const handleAddColumnView = values => {
        setCheckedList([...values, 'action']);
    };

    const getAllRowKeys = item => {
        return item.reduce((keys, value) => {
            keys.push(value.code);

            if (value.keyResults) {
                keys = keys.concat(getAllRowKeys(value.keyResults));
            }

            return keys;
        }, []);
    };


    const createColumns = () => {
        const column = [];
        column.push({
            key: 'action',
            fixed: 'left',
            width: 50,
            filterDropdown: () => (
                <Checkbox.Group
                    className="d-grid gap-3 p-3 overflow-auto height-350 align-items-center"
                    value={checkedList}
                    options={_.uniqBy([...createPinColumns(), ...columns, ...columnsExpand], (o) => { return o.key }).map(x => {
                        return {
                            label: x.title,
                            value: x.key,
                        };
                    })}
                    onChange={handleAddColumnView}
                />
            ),
            filterIcon: () => <FilterFilled style={{ color: checkedList.length > 0 ? '#1890ff' : undefined }} />,
            render: (record) => {
                return record.objectiveId &&
                    currentCheckInType === CurrentCheckInType.Year && <Tooltip className='cursor-pointer' title="Xem ý kiến đánh giá khác">
                        <FontAwesomeIcon
                            onClick={(event) => {
                                event.stopPropagation(); // Stop the event from propagating to the row
                                handleGetOtherComments(record.id);
                            }}
                            icon="eye"
                            color='blue'
                        />
                    </Tooltip>
            }

        },
        );

        column.push(...createPinColumns(), ...columns, ...columnsExpand);
        return column;
    };

    const handleTypeKrCheckIn = (item) => {
        if (filters.checkInPeriod) {
            if (filters?.checkInPeriod === CheckInType.Periodic) {
                switch (_.parseInt(currentCheckInType, 10)) {
                    case 0:
                        handleOpenModalReportKrHalfMonth(item);
                        break;
                    case 1:
                        handleOpenModalReportKrMonth(item);
                        break;
                    case 2:
                        handleOpenModalReportKr(item)
                        break;
                    case 3:
                        handleOpenModalReportKrFirstQuarter(item)
                        break;
                    default:
                        handleOpenModalKrYear(item)
                        return;
                }
            }
            else {
                handleOpenModalDraftKrYear(item);
            }
        }
    }

    const handleOpenModalReportKrFirstQuarter = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportKrFirstQuarter(true);
    };

    const handleCloseModalReportKrFirstQuarter = () => {
        setOpenModalReportKrFirstQuarter(false);
        setKrBaseSelected(null)
        getAllEntities();
    };

    const handleOpenModalReportKr = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportKr(true);
    };

    const handleCloseModalReportKr = () => {
        setOpenModalReportKr(false);
        setKrBaseSelected(null)
        getAllEntities();
    };

    const handleOpenModalDraftKrYear = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportDraftKrYear(true);
        setReload(false);
    };

    const handleCloseModalDraftKrYear = (reload = false) => {
        setOpenModalReportDraftKrYear(false);
        setKrBaseSelected(null)
        setReload(reload);

    };

    const handleOpenModalKrYear = (dataKr = null) => {
        setReload(false);
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportKrYear(true);
    };

    const handleCloseModalKrYear = (reload = false) => {
        setOpenModalReportKrYear(false);
        setKrBaseSelected(null)
        setReload(reload);
    };

    const handleOpenModalReportKrMonth = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportKrMonth(true);
    };

    const handleCloseModalReportKrMonth = (reload = false) => {
        setReload(false);
        setOpenModalReportKrMonth(false);
        setKrBaseSelected(null)
        setReload(reload);
    };

    const handleOpenModalReportKrHalfMonth = (dataKr = null) => {
        setReload(false);
        if (dataKr) {
            setKrBaseSelected(dataKr)
        }
        setOpenModalReportKrHalfMonth(true);
    };

    const handleCloseModalReportKrHalfMonth = (reload = false) => {
        setOpenModalReportKrHalfMonth(false);
        setKrBaseSelected(null)
        setReload(reload);
    };

    const handleRowClick = (event, record) => {
        event.preventDefault();
        if (record?.objectiveId) {
            localStorage.setItem('scrollToRow', record.code);
            handleTypeKrCheckIn(record)
        }
    };

    const handleChangePlanPeriod = (value: string) => {
        const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
        if (detailPlanPeriod) {
            dispatch(
                setFilterOrgCheckIn({
                    ...filters,
                    reportScheduleId: null,
                    planPeriodName: detailPlanPeriod.name,
                    planPeriodId: value,
                    startDate: dayjs(detailPlanPeriod.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                    dueDate: dayjs(detailPlanPeriod.endDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                    planPeriodType: detailPlanPeriod.planPeriodType,
                    year: detailPlanPeriod.year,
                    month: detailPlanPeriod.month,
                    quarter: detailPlanPeriod.quarter,
                }),
            );
        }
    };

    const handleChangeAdjustPlanPeriods = value => {
        dispatch(
            setFilterOrgCheckIn({
                ...filters,
                adjustPlanPeriod: value,
            }),
        );
    };

    const handleChangeReportSchedule = value => {
        dispatch(
            setFilterOrgCheckIn({
                ...filters,
                reportScheduleId: value,
            }),
        );
    };

    const handleChangePeriodCheckIn = (value) => {
        const checkInPeriod = _.find(checkInPeriods, o => o.periodType === value);
        if (checkInPeriod) {
            dispatch(
                setFilterOrgCheckIn({
                    ...filters,
                    planPeriodType: checkInPeriod.planPeriodType,
                    checkInPeriod: value,
                    reportScheduleId: checkInPeriod.value,
                }),
            );
        }
    };

    const handleChangeCheckInStatus = value => {
        dispatch(setFilterOrgCheckIn({ ...filters, checkInStatus: value }));
    }

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterOrgCheckIn({ ...filters, searchText: query }));
    };

    const handleTypeKrConfirmComplete = () => {
        if (filters?.checkInPeriod === CheckInType.Draft) {
            setOpenModalConfirmCompleteDraftYear(true)
        }
        else if (currentCheckInType) {
            switch (_.parseInt(currentCheckInType, 10)) {
                case 0:
                    setOpenModalConfirmCompleteHalfMonth(true);
                    break;
                case 1:
                    setOpenModalConfirmCompleteMonth(true);
                    break;
                case 2:
                    setOpenModalConfirmComplete(true)
                    break;
                case 3:
                    setOpenModalConfirmCompleteQuarter(true)
                    break;
                case 4:
                    handleOpenModalEvaluateYear()
                    break;
                default:
                    return;
            }
        }
    }

    const handleChange = (pageNumber: number, size: number, sorter: any) => {
        setPaginationState({
            ...paginationState,
            order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
            sort: sorter.columnKey,
            activePage: pageNumber,
            itemsPerPage: size,
        });
    };

    const handleClose = () => {
        onClose(isReload);
    }

    const getAllEntities = () => {
        // Why BE xử lí checkin qua event nên yêu cầu chờ 1s
        // Để lấy kết quả mới nhất
        // Nếu không sẽ bị lấy kết quả trước khi checkin
        setTimeout(() => {
            dispatch(getCheckInByAccountableId({
                searchText: filters?.searchText,
                accountableId: filters?.accountableId,
                checkinStatus: filters?.checkInStatus,
                checkInPeriod: filters?.checkInPeriod,
                krAccountableId: filters?.krAccountableId,
                fieldValue: filters?.fieldValue,
                projectId: filters?.projectId,
                workStatus: filters?.workStatus,
                workTypeId: filters?.workTypeId,
            }))
        }, 1000);
    }

    const handleCloseFilter = (item) => {
        const { krAccountableId, fieldValue, projectId, workStatus, workTypeId } = item;
        dispatch(
            setFilterOrgCheckIn({
                ...filters,
                krAccountableId,
                fieldValue,
                projectId,
                workStatus,
                workTypeId,
            }),
        );
        setFilterModalVisible(false)
    }


    const handleCurrentCheckIn = async () => {
        const response = await dispatch(getCurrentCheckInType())

        if (response && response.payload) {
            const result = response.payload as any
            setCurrentCheckInType(result?.data?.checkinType)

        }
    }

    const handleOpenModalEvaluateYear = () => {
        setOpenModalEvaluateYear(true)
    }

    const handleCloseModalEvaluateYear = () => {
        setOpenModalEvaluateYear(false)
    }

    const handleOpenModalOtherComment = () => {
        setOpenModalOtherComment(true);
    }

    const handleCloseModalOtherComment = () => {
        setOpenModalOtherComment(false);
    }

    const handleGetOtherComments = (value) => {
        setLoadingComment(true);
        handleOpenModalOtherComment()
        dispatch(getOtherComment({ itemId: value, ownerId: filters?.accountableId, planPeriodId: filters?.planPeriodId })).finally(() => { setLoadingComment(false) });
    }

    return (
        <Modal onCancel={() => { handleClose() }} open={isOpen} maskClosable={false} width={1300} footer={null}>
            <Container className="view">
                <div className="d-flex gap-5 mt-2">
                    <Row className="d-flex justify-content-between w-100">
                        <Col md={24}>
                            <Row>
                                <Col md={13}>
                                    <Title level={3}>{`Check in mục tiêu & KR ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </div>
                <div className="table">
                    <div className="header">
                        <Col md={14}>
                            <Row className='w-100'>
                                <Col md={5}>
                                    <Select
                                        className="w-100"
                                        value={filters?.checkInPeriod}
                                        options={checkInPeriods.map(x => {
                                            return {
                                                ...x,
                                                value: x.periodType
                                            }
                                        })}
                                        onChange={handleChangePeriodCheckIn}
                                        filterOption={filterOption}
                                        placeholder="Chọn kỳ check in"
                                        size="large"
                                    />
                                </Col>
                                <Col md={1} />
                                <Col md={6}>
                                    <Select
                                        className="w-100"
                                        value={filters?.checkInStatus}
                                        defaultValue={null}
                                        options={krCheckInStatus}
                                        onChange={handleChangeCheckInStatus}
                                        filterOption={filterOption}
                                        size="large"
                                    />
                                </Col>
                                <Col md={1} />
                                <Col md={6}>
                                    <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                                </Col>
                                <Col md={1}>
                                    <Button
                                        className={`filter primary ${(filters?.krAccountableId ||
                                            filters?.fieldValue ||
                                            filters?.projectId ||
                                            filters?.workStatus || filters?.workTypeId) ? 'active-filter' : ''}`}
                                        size="large"
                                        onClick={() => {
                                            setFilterModalVisible(true);
                                        }}
                                        icon={<ReactSVG src={'content/images/icons/filter.svg'} />}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Col md={10}>
                            <Row className='w-100 justify-content-end d-flex gap-1'>
                                {/* {currentCheckInType === CurrentCheckInType.Year &&
                                    <Col md={11}>
                                        <Button
                                            size="large"
                                            onClick={() => {
                                                setOpenModalConfirmCompleteQuarter(true);
                                            }}
                                            className="primary"
                                        >
                                            Xác nhận hoàn thành check in quý 4
                                        </Button>
                                    </Col>
                                } */}
                                <Col md={1} />
                                <Col md={11}>
                                    <Button
                                        size="large"
                                        onClick={() => {
                                            handleTypeKrConfirmComplete();
                                        }}
                                        className="primary"
                                    >
                                        {filters?.checkInPeriod !== CheckInType.Draft ? currentCheckInType !== CurrentCheckInType.Year ?
                                            'Xác nhận hoàn thành check in' : 'Xác nhận hoàn thành đánh giá năm' :
                                            'Xem tổng hợp kết quả thực hiện'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
                <TableComponent
                    data={data.map((x, index) => {
                        return {
                            key: x.code,
                            ...x,
                            children: x.children && x.children.map(y => {
                                return {
                                    key: y.code,
                                    ...y,
                                };
                            }),
                        };
                    })}
                    scroll={true}
                    total={totalItems}
                    isFetching={isLoading}
                    tableLayout="fixed"
                    columns={newColumns}
                    expandedRowKeys={expandedRowKeys}
                    handleRowClick={(event, record) => { handleRowClick(event, record) }}
                    setExpandedRowKeys={setExpandedRowKeys}
                    expandIconColumnIndex={_.filter(newColumns, (o) => {
                        return !o.hidden
                    }).findIndex(column => column.key === 'purposeYear')}
                    handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
                        handleChange(pageNumber, size, sorter);
                    }}
                />

                {visibleFilter && <FilterCheckInModal visible={visibleFilter} onCancel={handleCloseFilter} />}
                {isOpenModalConfirmComplete &&
                    <ConfirmComplete
                        isOpen={isOpenModalConfirmComplete}
                        onClose={() => {
                            setOpenModalConfirmComplete(false);
                        }}
                    />
                }
                {isOpenModalConfirmCompleteDraftYear &&
                    <ConfirmCompleteDraftYear
                        isOpen={isOpenModalConfirmCompleteDraftYear}
                        onClose={() => {
                            setOpenModalConfirmCompleteDraftYear(false);
                        }}
                    />
                }
                {isOpenModalConfirmCompleteQuarter &&
                    <ConfirmCompleteQuarter
                        isOpen={isOpenModalConfirmCompleteQuarter}
                        isShow={currentCheckInType !== CurrentCheckInType.Year}
                        onClose={() => {
                            setOpenModalConfirmCompleteQuarter(false);
                        }}
                    />
                }
                {isOpenModalConfirmCompleteHalfMonth &&
                    <ConfirmCompleteHalfMonth
                        isOpen={isOpenModalConfirmCompleteHalfMonth}
                        onClose={() => {
                            setOpenModalConfirmCompleteHalfMonth(false);
                        }}
                    />
                }
                {isOpenModalConfirmCompleteMonth &&
                    <ConfirmCompleteMonth
                        isOpen={isOpenModalConfirmCompleteMonth}
                        onClose={() => {
                            setOpenModalConfirmCompleteMonth(false);
                        }}
                    />
                }
                {isOpenModalReportKrYear &&
                    <ReportYear isOpen={isOpenModalReportKrYear} onClose={handleCloseModalKrYear} krSelected={krBaseSelected} />
                }
                {isOpenModalReportDraftKrYear &&
                    <ReportDraftYear isOpen={isOpenModalReportDraftKrYear} onClose={handleCloseModalDraftKrYear} krSelected={krBaseSelected} />
                }
                {isOpenModalReportKrHalfMonth && <ReportHalfMonth krSelected={krBaseSelected} isOpen={isOpenModalReportKrHalfMonth} onClose={handleCloseModalReportKrHalfMonth} />}
                {isOpenModalReportKrMonth && <ReportMonth krSelected={krBaseSelected} isOpen={isOpenModalReportKrMonth} onClose={handleCloseModalReportKrMonth} />}
                {isOpenModalReportKr && <ReportMidYear krSelected={krBaseSelected} isOpen={isOpenModalReportKr} onClose={handleCloseModalReportKr} />}
                {isOpenModalReportKrFirstQuarter && <ReportQuarter krSelected={krBaseSelected} isOpen={isOpenModalReportKrFirstQuarter} onClose={handleCloseModalReportKrFirstQuarter} />}
                {isOpenModalOtherComment && <OtherCommentComponent isLoading={isLoadingComment}
                    data={otherComment} isOpen={isOpenModalOtherComment}
                    onClose={handleCloseModalOtherComment} />}
                {isOpenModalEvaluateYear &&
                    <SelfEvaluationObjectiveKRComponent
                        accountTableId={filters?.accountableId}
                        accountableName={filters?.accountableName}
                        isOpen={isOpenModalEvaluateYear}
                        onClose={handleCloseModalEvaluateYear} />}
            </Container>
        </Modal>
    );
}

export default OrganizationActiveCheckIn;
